import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Chart = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M17.526 11h2c0.552 0 1 0.448 1 1v12c0 0.552-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1v-12c0-0.552 0.448-1 1-1zM12.263 7h2c0.552 0 1 0.448 1 1v16c0 0.552-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1v-16c0-0.552 0.448-1 1-1zM7 12h2c0.552 0 1 0.448 1 1v11c0 0.552-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1v-11c0-0.552 0.448-1 1-1zM22.789 17h2c0.552 0 1 0.448 1 1v6c0 0.552-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1v-6c0-0.552 0.448-1 1-1z" />
  </SvgIcon>
);

export default Chart;
